import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import ColumnBtnCard from '../atoms/columnBtnCard'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.article`
  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    span {
      display: none;
    }
  }
  ${BreakPoints.large} {
    margin-bottom: 10px;
  }
`

/**
 * 関連記事カードセット
 * TODO 川上申し送り事項：記事詳細下部に表示されるコンポーネントです。
 * ここでは、表示している記事に関連した他の記事3件が表示される予定です
 * @constructor
 */
const ColumnRelationCards0062 = () => {
  const routeParam = useRouteParam('/column/details/C0006')
  const routeParam2 = useRouteParam('/column/details/C0010')
  const routeParam3 = useRouteParam('/column/details/C0028')
  return (
    <Wrapper>
      <ColumnH1 label="関連コラム" />
      <section>
        <ColumnBtnCard
          href={routeParam}
          imgId="c0006.jpg"
          label="通常の労働時間制（固定労働時間制度）と変形労働時間制とは？"
          date="2022.04.15"
        />
        <ColumnBtnCard
          href={routeParam2}
          imgId="c0010.jpg"
          label="裁量労働制とはどんな制度？内容やメリット・デメリットを解説"
          date="2022.04.15"
        />
        <ColumnBtnCard
          href={routeParam3}
          imgId="c0028.jpg"
          label="みなし残業とは？間違えやすいみなし労働時間制との違いまで解説"
          date="2022.04.15"
        />
      </section>
    </Wrapper>
  )
}

export default ColumnRelationCards0062
